module.exports = __webpack_public_path__ + "static/media/C (10).2e1ebc30.jpg";